import React from 'react';
import { renderFieldDisplay } from '../../util';
import { tipoIdentificacion } from '../../catalogos';

const ProfileDisplay = (props) => {
  const { profile, isEmisor } = props;

  const getIdentificacionTipo = (type) => {
    if (type == null) {
      return '';
    }
    return tipoIdentificacion.filter((item) => item.value === type)[0].display;
  };

  return (
    <>
      <div className="ui grid profile-display-section">
        <div className="section-header">
          {!isEmisor ? (<h4>Información del cliente</h4>) : ('')}
        </div>
        <div className="doubling three column row min-padding">
          <div className="column">
            {renderFieldDisplay('Tipo identificación:', getIdentificacionTipo(profile?.Identificacion?.Tipo))}
          </div>
          <div className="column">
            {renderFieldDisplay('Identificación:', profile?.Identificacion?.Numero)}
          </div>
          <div className="column">
            {renderFieldDisplay('Email:', profile?.CorreoElectronico)}
          </div>
        </div>
        <div className="stacked row min-padding">
          <div className="column">
            {renderFieldDisplay('Nombre:', profile?.Nombre)}
          </div>
          {isEmisor ? (<>
            <div className="column">
              {renderFieldDisplay('Nombre Comercial:', profile?.NombreComercial)}
            </div>
            <div className="column">
              {renderFieldDisplay('Teléfono:', profile?.Telefono ? profile.Telefono.NumTelefono : '')}
            </div>  </>) : ('')}
        </div>

      </div>
    </>
  );
};

export default ProfileDisplay;